import { ContentCard } from './Cards';
const coachesAtAlmaBetter = [
  {
    icon: '/assets/images/become-a-coach/Group 10000023083x.png',
    title: 'Instructors',
    value: 'Instructors are coaches who teach the students in live classes.',
  },
  {
    icon: '/assets/images/become-a-coach/Group 10000023073x.png',
    title: 'Mentors',
    value: 'Mentors are coaches who guide the students in their journey.',
  },
  {
    icon: '/assets/images/become-a-coach/Group 1000002361@2x (2).png',
    title: 'Subject Matter Experts',
    value: 'Subject Matter Experts are coaches who help us publish technical content.',
  },
];

const howItWorks = [
  {
    icon: '/assets/images/become-a-coach/Group 1000002442@2x.png',
    title: 'Sign up & complete profile',
    value: 'Book a demo session to get detailed information on our hiring proposition',
  },
  {
    icon: '/assets/images/become-a-coach/Group 1000002441.png',
    title: 'Get verified as Coach',
    value:
      'Save time by avoiding scrutiny on a pile of resumes. Talk to our top performers directly',
  },
  {
    icon: '/assets/images/become-a-coach/Group 1000002439.png',
    title: 'Start Coaching',
    value:
      'Conduct interviews on your own OR use our in-house video-interview platform to do interviews seamlessly',
  },
];

export function CoachesAtAlmaBetter() {
  return (
    <div className="my-20 flex w-full flex-col items-center justify-center lg:my-32">
      <h2 className="heading-2 my-2 text-[22px] lg:text-4xl">Coaches at AlmaBetter</h2>
      <div className="grid grid-flow-row grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 lg:gap-2">
        {coachesAtAlmaBetter.map((item, index) => (
          <ContentCard
            key={index}
            bgColor="bg-white"
            align="items-center"
            text="text-center"
            content={item}
            width="w-full"
            height="h-[200px]"
          />
        ))}
      </div>
    </div>
  );
}

export function HowItWorks() {
  return (
    <div className="my-32 flex w-full flex-col items-center justify-center">
      <h1 className="mb-8">How it works</h1>
      <div className="grid grid-flow-row grid-cols-2 gap-2 bg-yellow-light lg:grid-cols-3">
        {howItWorks.map((item, index) => (
          <ContentCard
            key={index}
            bgColor="bg-yellow-light"
            align="items-center"
            text="text-center"
            content={item}
            width="w-full"
            height="h-[200px]"
          />
        ))}
      </div>
    </div>
  );
}
